import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Bolagets ekonomi", -1)
const _hoisted_2 = { class: "revenue" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "Omsättning", -1)
const _hoisted_4 = { class: "result" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Nettovinst", -1)
const _hoisted_6 = { class: "result" }
const _hoisted_7 = { class: "money-left" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "personal-finances" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Privatekonomi", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Månadslön (före skatt)", -1)
const _hoisted_15 = { class: "result" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Månadslön (efter skatt)", -1)
const _hoisted_17 = { class: "result" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "Utdelning (efter skatt)", -1)
const _hoisted_19 = { class: "result" }
const _hoisted_20 = {
  key: 0,
  class: "dividend-info"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }

import { formatter } from "@/formatter";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoTable',
  props: {
  revenue: {
    type: Number,
    default: 0,
    value: Number,
  },
  netProfit: {
    type: Number,
    default: 0,
  },
  dividendSimplifiedRule: {
    type: Number,
    default: 220671,
  },
  dividendMainRule: {
    type: Number,
    default: 0,
  },
  monthsWorthOfSalary: {
    type: Number,
    default: 6,
  },
  salary: {
    type: Number,
    default: 53100,
  },
  mainRule: {
    type: Number,
    default: 0,
  },
  simpleRule: {
    type: Number,
    default: 0,
  },
  netSalary: {
    type: Number,
    default: 35294,
  },
  currentDividend: {
    type: Number,
    default: 220671,
  },
  taxOnDividend: {
    type: Number,
    default: 0.2,
  },
},
  setup(__props) {

const props = __props;



let dividend = ref(props.currentDividend);
let taxOnDiv = ref(props.taxOnDividend);

const divWithTax = computed(() => {
  let tax = dividend.value * taxOnDiv.value;
  return dividend.value - tax;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatter).format(__props.revenue)) + " kr", 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatter).format(__props.netProfit)) + " kr", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.monthsWorthOfSalary >= 1 && __props.netProfit >= __props.salary * 1.3142)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Pengar kvar i bolaget är " + _toDisplayString(_unref(formatter).format(__props.netProfit)) + " kr och det motsvarar ca " + _toDisplayString(__props.monthsWorthOfSalary) + " månadslöner ", 1))
        : _createCommentVNode("", true),
      (__props.netProfit <= 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createTextVNode(" Du har nu ingen vinst, och därmed inget sparat kapital i bolaget. Därför kan du ej ta ut någon utdelning eller se sparade hur många månader värt av lön du kan få. "),
            _hoisted_10,
            _createTextVNode(" Ett tips är att höja ditt timarvode, och/eller öka antal timmar du arbetar. Du kan också sänka din lön, men det är inget vi rekommenderar. ")
          ]))
        : (__props.salary * 1.3142 >= __props.netProfit)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Det finns inte tillräckligt med vinst för att betala ut en månadslön. Sänk din lön, eller öka dina intäkter för att spara fler månader med lön. "))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatter).format(__props.salary)) + " kr", 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatter).format(__props.netSalary)) + " kr", 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_18,
          _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatter).format(Math.round(divWithTax.value))) + " kr ", 1)
        ])
      ])
    ]),
    (__props.currentDividend <= 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Du tar nu ingen utdelning, och maxar därmed din nettovinst för exempelvis längre semester, eller månader utan uppdrag."))
      : (__props.currentDividend <= 220671 && __props.currentDividend > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Du tar nu utdelning enligt förenklingsregeln. Du kan alltid ta ut mindre än max beloppet om vinsten är tillräckligt hög. Skatt på 20% tillkommer. "))
        : (__props.salary >= 37300 && __props.salary * 12 > 613700)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Du tar nu din utdelning enligt huvudregeln, som innebär att du tjänar minst 448 422 kr brutto 2023 och har en tillräckligt hög vinst. Skatt tillkommer på 20% "))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, " Det finns inte tillräckligt med lön och vinst för att du ska kunna ta utdelning enligt huvudregeln. Öka din lön till minst 37 500 kr för att kunna nyttja denna regel. "))
  ]))
}
}

})